export { default } from "./PhotoGallery";
